import React from 'react';
import AppRouter from './config/router'
import { initFirebase } from './helpers/firebase';
initFirebase();
function App() {
  return (<AppRouter/>);
}

export default App;
